// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certificates-container {
  background-color: #F2F2F7;
  padding: 3% 15.5% 9%;
}
@media screen and (max-width: 768px) {
  .certificates-container {
    padding: 7% 5.5% 12%;
  }
}
@media screen and (max-width: 414px) {
  .certificates-container {
    padding: 7% 5.5% 17%;
  }
}
.certificates-list {
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 768px) {
  .certificates-list {
    flex-wrap: wrap;
  }
}
@media screen and (max-width: 565px) {
  .certificates-list {
    gap: 20px;
    justify-content: start;
  }
}
.certificates-item {
  padding: 30px;
  border-radius: 20px;
  border: 1px solid #FCAF17;
  background-color: #fff;
  width: 31.5%;
}
@media screen and (max-width: 768px) {
  .certificates-item {
    padding: 24px;
    min-width: 168px;
  }
}
@media screen and (max-width: 414px) {
  .certificates-item {
    padding: 16px;
  }
}
.certificates-item .pdf {
  font-size: 12px;
  font-weight: 500;
  line-height: 19px;
  padding: 0px 16px;
  display: block;
  width: 54px;
  height: 19px;
  margin-bottom: 9px;
  color: #FCAF17;
  border-radius: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.certificates-item h4 {
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  margin-top: 15px;
  padding-bottom: 25px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 40px;
}
.certificates-item .borders {
  border-bottom: 1px solid #F2F2EA;
  width: 100%;
  display: block;
  height: 2px;
  margin-top: 14px;
  margin-bottom: 19px;
}
@media screen and (max-width: 414px) {
  .certificates-item .borders {
    margin-top: 19px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/CertificatesList.scss"],"names":[],"mappings":"AACI;EACI,yBAAA;EACA,oBAAA;AAAR;AACQ;EAHJ;IAIQ,oBAAA;EAEV;AACF;AADQ;EANJ;IAOQ,oBAAA;EAIV;AACF;AAFI;EACI,aAAA;EACA,8BAAA;AAIR;AAHQ;EAHJ;IAIO,eAAA;EAMT;AACF;AAJQ;EAPJ;IAQQ,SAAA;IACA,sBAAA;EAOV;AACF;AALI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AAOR;AANQ;EANJ;IAOQ,aAAA;IACA,gBAAA;EASV;AACF;AARQ;EAVJ;IAWQ,aAAA;EAWV;AACF;AATQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;AAWZ;AARQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AAUZ;AARQ;EACI,gCAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAUZ;AATY;EAPJ;IAQQ,gBAAA;EAYd;AACF","sourcesContent":[".certificates {\n    &-container {\n        background-color: #F2F2F7;\n        padding: 3% 15.5% 9%;\n        @media screen and (max-width: 768px) {\n            padding: 7% 5.5% 12%;\n        }\n        @media screen and (max-width: 414px) {\n            padding: 7% 5.5% 17%;\n        }\n    }\n    &-list {\n        display: flex;\n        justify-content: space-between;\n        @media screen and (max-width: 768px) {\n           flex-wrap: wrap;\n        \n        }\n        @media screen and (max-width: 565px) {\n            gap: 20px;\n            justify-content: start;\n        }\n    }\n    &-item {\n        padding: 30px;\n        border-radius: 20px;\n        border: 1px solid #FCAF17;\n        background-color: #fff;\n        width: 31.5%;\n        @media screen and (max-width: 768px) {\n            padding: 24px;\n            min-width: 168px;\n        }\n        @media screen and (max-width: 414px) {\n            padding: 16px;\n        }\n\n        .pdf {\n            font-size: 12px;\n            font-weight: 500;\n            line-height: 19px;\n            padding: 0px 16px;\n            display: block;\n            width: 54px;\n            height: 19px;\n            margin-bottom: 9px;\n            color: #FCAF17;\n            border-radius: 40px;\n            border: 1px solid rgba(0, 0, 0, 0.2);\n        }\n\n        h4 {\n            font-size: 18px;\n            font-weight: 600;\n            line-height: 20px;\n            margin-top: 15px;\n            padding-bottom: 25px;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 2;\n            overflow: hidden;\n            height: 40px;\n        }\n        .borders {\n            border-bottom: 1px solid #F2F2EA;\n            width: 100%;\n            display: block;\n            height: 2px;\n            margin-top: 14px;\n            margin-bottom: 19px;\n            @media screen and (max-width: 414px) {\n                margin-top: 19px;\n            }\n        }\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
